import { cn } from 'app/lib/utils'
import { parseTheme } from 'app/lib/parseConfigTheme'

const WidgetWrapper = ({
    width = 'small',
    children,
    className,
    style,
    ref,
    config
}: {
    width?: 'small' | 'medium' | 'large' | 'full'
    children: React.ReactNode
    className?: string
    style?: React.CSSProperties
    ref?: React.RefObject<HTMLDivElement>
    config?: IDomainConfig
}) => {
    // Get layout size from theme
    const theme = config?.theme ? parseTheme(config.theme) : null
    const layoutSize = theme?.branding?.layout_size || 'compact'
    const isWide = layoutSize === 'wide'

    // Use max-w-[5000px] for wide layout, otherwise use width-based max-width
    const maxWidthClass = isWide
        ? 'max-w-[5000px]'
        : width === 'small'
          ? 'max-w-[1400px]'
          : width === 'medium'
            ? 'max-w-[1900px]'
            : width === 'large'
              ? 'max-w-[2400px]'
              : 'max-w-[100%]'

    return (
        <div
            className={cn('lg:w-full !w-[95%] md:!w-[90%] mx-auto', maxWidthClass, className)}
            style={style ? style : undefined}
            ref={ref ? ref : undefined}
        >
            {children}
        </div>
    )
}

export const PolygonWidgetWrapper = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <div
        className={cn('grid w-full px-4 !max-w-[5000px] md:px-6 lg:px-[5vw] mx-auto  text-pfl_v2_text_test', className)}
    >
        {children}
    </div>
)

export default WidgetWrapper
